import React, { forwardRef } from 'react';

const VARIANT_CLASS = {
  primary: 'btn-primary',
  secondary: 'btn-secondary',
  ghost: 'btn-ghost',
};

/**
 * @param {object} props
 * @param {'primary'|'secondary'|'ghost'} [props.variant='primary']
 * @param {string} [props.className]
 * @param {React.ReactNode} props.children
 */
const Button = forwardRef(function Button(
  { variant = 'primary', className = '', children, type = 'button', disabled, ...rest },
  ref
) {
  const base = VARIANT_CLASS[variant] || VARIANT_CLASS.primary;
  return (
    <button
      ref={ref}
      type={type}
      disabled={disabled}
      className={`${base} ${disabled ? 'opacity-50 cursor-not-allowed' : ''} ${className}`.trim()}
      {...rest}
    >
      {children}
    </button>
  );
});

export default Button;
